<template>
  <v-container>
    <v-row>
      <v-radio-group
              v-model="selectValue"
              :rules="rules"
              @keypress.enter="onSubmit"
              :row="row"
      >
        <v-radio
                v-for="(item, index) in items"
                :key="index"
                :value="item.value"
                :label="item.label"
                :class="itemClass(item)"
        />
      </v-radio-group>
    </v-row>
    <v-row>
      <TextField
              v-if="showOther"
              v-model="otherValue"
              :name="otherName"
              :disabled="disabledOther"
              :required="requiredOther"
              :submit="submit"
      />
    </v-row>
  </v-container>
</template>

<script>
  import TextField from "./TextField";
  import ComponentMixin from "../ComponentMixin";

  export default {
    mixins: [ComponentMixin],
    type: "atom",
    name: "RadioField",
    props: {
      "value": [Object,Boolean],
      "name": String,
      "row": Boolean,
      "other": {
        type: Number,
        default: null
      },
      "otherName": String,
      "items": Array,
      "required": Boolean,
      "submit": Function,
      highlight: {
        type: [Object, Boolean],
        default: null
      }
    },
    computed: {
      selectValue: {
        get () {
          return this.value ? this.value.select : null
        },
        set (value) {
          this.$emit("input", {select: value, other: null})
        }
      },
      otherValue: {
        get () {
          return this.value ? this.value.other : null
        },
        set (value) {
          this.$emit("input", {...this.value, other: value})
        }
      },
      showOther () {
        return this.other !== null
      },
      disabledOther () {
        return this.selectValue !== this.other
      },
      requiredOther () {
        return !this.disabledOther && this.required
      },
      rules () {
        return [
          value => {
            if (this.required) {
              if (value === 0 || value === false) {
                return true;
              }
              return !!value || this.error("required", [this.name]);
            }
            return true;
          }
        ]
      }
    },
    methods: {
      onSubmit () {
        if (this.submit) {
          this.submit()
        }

      },
      itemClass(item) {
        if (item.value === this.highlight) {
          return ["highlight"]
        }
      }
    },
    components: {TextField}
  }
</script>

<style scoped>
div.v-radio.highlight {
  background-color: rgba(122, 171, 204, 0.2);
}
</style>
